<template>
  <div class="container mb-25px">
    <div class="progress-title">
      distance
    </div>
    <div class="progress-section d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <div class="progress-status d-flex flex-column">
          <span class="progress-text">Parking to Pickup</span>
        </div>
      </div>
      <div class="progress-time">{{ distance.company_to_pickup }} miles</div>
    </div>
    <div class="progress-section d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <div class="progress-status d-flex flex-column">
          <span class="progress-text">Delivery to Pickup</span>
        </div>
      </div>
      <div class="progress-time">{{ distance.dropoff_to_company }} miles</div>
    </div>
    <div class="progress-section d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <div class="progress-status d-flex flex-column">
          <span class="progress-text">Deadhead (when truck is empty)</span>
        </div>
      </div>
      <div class="progress-time">{{ distance.deadhead }} miles</div>
    </div>
    <div class="progress-section d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <div class="progress-status d-flex flex-column">
          <span class="progress-text">Pickup to Delivery (all addresses)</span>
        </div>
      </div>
      <div class="progress-time">{{ distance.route }} miles</div>
    </div>
    <div class="progress-section d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <div class="progress-status d-flex flex-column">
          <span class="progress-text">Parking to Parking</span>
        </div>
      </div>
      <div class="progress-time">{{ distance.total }} miles</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    distance: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
.progress-section {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Distance.vue